"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formatMoney = function (amount) {
    if (amount === void 0) { amount = 0; }
    amount = amount * 100;
    var options = {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
    };
    if (amount % 100 === 0) {
        options.minimumFractionDigits = 0;
    }
    var formatter = Intl.NumberFormat('en-US', options);
    return formatter.format(amount / 100);
};
exports.default = formatMoney;
